// src/lib/mmsToolEvents.js
/**
 * Dispatches a custom event to notify other parts of the application,
 * particularly the parent MMS environment, that a tool-related action has been completed.
 * This is used for triggering events like showing a sticker drawer when a student
 * completes a practice goal or a quiz.
 *
 * @param {object} detail - The event payload.
 * @param {string} detail.noteBlockId - The unique identifier for the tool's node block.
 * @param {string} detail.earnedFor - A description of what the completion reward is for.
 * @param {object} [detail.payload] - Any additional data to pass with the event.
 */
export function emitToolCompleted(detail) {
  if (typeof window === 'undefined' || typeof CustomEvent === 'undefined') return;
  const event = new CustomEvent('mms:toolCompleted', {
    detail,
    bubbles: true,
    composed: true,
  });
  window.dispatchEvent(event);
}